import React from "react";
import "./hero.css";

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1>Entrenamiento y Nutrición Saludable</h1>
        <p>Alimenta tu cuerpo y potenciá tu rendimiento con un enfoque integral para transformar tu bienestar.</p>
        <a href="/contacto" className="hero-btn">Comenzar Hoy</a>
      </div>
    </section>
  );
}
